import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        root:
            'group rounded-[0.8rem] border-[0.063rem] border-solid border-(--glass-chip-border) bg-(--glass-chip-bg) ' +
            'px-3 py-2 shadow-[0_0.125rem_0.4rem_rgba(100,116,139,0.08)] ' +
            'transition-[border-color,background-color,box-shadow] duration-150 ease-out ' +
            'hover:border-(--glass-chip-border-hover) hover:bg-(--glass-chip-bg-hover) ' +
            'hover:shadow-(--estimate-summary-card-shadow)',
        heading: 'flex items-center justify-between gap-3',
        name:
            'text-[0.88rem] text-(--text-light) transition-colors duration-150 group-hover:font-semibold ' +
            'group-hover:text-(--text-dark)',
        rate: 'font-(family-name:--primary-font) text-[0.88rem] text-(--text-dark) group-hover:font-semibold',
        amount:
            'mt-1 text-[0.78rem] text-(--text-muted) transition-colors duration-150 group-hover:font-semibold ' +
            'group-hover:text-(--text-light)'
    }
} satisfies ComponentTheme;
